import { commonfunc } from '@/mixin/common'
const ugMixin = {
  mixins: [commonfunc],
  data () {
    return {
      baseUrl: process.env.VUE_APP_ENV === 'loc' ? 'http://localhost:8011' : process.env.CDN_BASE_URL,
      // mbMngNo: this.$store.getters['session/getMbMngNo'], // session 회원관리번호
      initMainTab: '1', // tab active initialization [ 1: 상품설명, 2: 리뷰,  3: QnA, 4: 상품정보(제공 고시) ]
      tabMove: false, // 탭 클릭 스크롤 이벤트 작동 체크
      scrollY: null, // scrollTop
      tabBlank: 182, // tab height (header h + nav + topmargin)
      tabMoveTarget: null, // 클릭 탭 offsetTop,

      tab: {
        // dc: {
        //   name: '1',
        //   title: '상품설명'
        // },
        // revw: {
        //   name: '2',
        //   title: '리뷰'
        // },
        // qna: {
        //   name: '3',
        //   title: 'Q&A'
        // },
        // info: {
        //   name: '4',
        //   title: '상품정보'
        // }
      }
    }
  },
  mounted () {

  },

  methods: {

    // 조회수 업데이트
    updateInct (ctenId) {
      try {
        this.$AxiosBuilder
          .data({ ctenId })
          .build()
          .post('/ug/common/updCtenInct')
          .then((res) => {
            if (!res.data.success) {
              console.log('조회수 증가 에러')
            }
          })
      } catch (e) {
        console.log('updateInct error : ', e)
      }
    },

    // 숫자 표기(만, 억단위로 표시하고 백의 자리에서 반올림)
    displayformatNumber (num) {
      if (num === null) {
        return '0'
      }

      if (typeof num === 'string') {
        num = Number(num)
      }

      if (num < 10000) {
        return num.toLocaleString('ko-KR')
      }

      let str = ''

      // 반올림하여 억/만으로 표시하여 리턴

      if (num < 1000000) {
        let mok = num / 10000
        console.log(mok)
        mok = Math.round(mok * 10) / 10
        console.log(mok)
        str = String(mok) + '만'
      } else {
        str = '99.9+만'
        // let mok = num / 100000000
        // mok = Math.round(mok * 10) / 10
        // str = String(mok) + '억'
      }

      return str
    },

    /**
     * 파일 업로드 시 validation 체크 - 이미지
    * @param {*} file
    * @returns
    */
    imgBeforeUpload (fileObj) {
      const file = fileObj
      const fileName = file.name

      let fileExt = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileExt = fileExt.toLowerCase()
      const fileType = fileExt === 'jpg' || fileExt === 'png' || fileExt === 'jpeg'
      if (!fileType) {
        this.$alert('지원하지 않는 이미지 파일 형식입니다.') // 이미지 파일만 업로드 가능합니다.
        return false
      }

      // 파일 업로드 가능 크기
      if (file.size > 20 * 1024 * 1024) {
        this.$alert('업로드 용량은 최대 20MB 입니다.') // MSG_DS_00000005: 업로드 용량은 최대 20MB 입니다.
        return false
      }

      return true
    },
    imgBeforeUploadForAuto (fileObj) {
      console.log(fileObj)
      const file = fileObj
      const fileName = file.name

      let fileExt = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileExt = fileExt.toLowerCase()
      const fileType = fileExt === 'jpg' || fileExt === 'png' || fileExt === 'jpeg'
      if (!fileType) {
        this.$alert('지원하지 않는 이미지 파일 형식입니다.')
        return false
      }

      // 파일 업로드 가능 크기
      if (file.size > 20 * 1024 * 1024) {
        this.$alert('업로드 용량은 최대 20MB 입니다.') // MSG_DS_00000005: 업로드 용량은 최대 20MB 입니다.
        return false
      }

      return true
    },

    // 스크롤 이동 시 해당 탭 active 셋팅
    activeTab (item) {
      for (let idx = 0; idx < item.length; idx++) {
        const tabContTop = item[idx].getBoundingClientRect().top
        const tabContHeight = item[idx].clientHeight
        if (tabContTop <= this.tabBlank && tabContTop + tabContHeight >= this.tabBlank) {
          // detailTabMove, detailTabActive 동시 작동 방지
          if (this.tabMove === false) {
            this.active = (idx + 1).toString()
          }
        }
      }
    },
    validHshTag (hshTag) {
      const regExp = /[^a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣0-9]/g
      return regExp.test(hshTag)
    },

    // 클릭한 탭으로 스크롤 이동
    tabScroll (tab, event) {
      this.tabMove = true
      const wrap = document.getElementsByClassName('content-section')[0].closest('.wrap')
      const targetTab = document.getElementsByClassName('tab-cont')[tab.name - 1]
      this.tabMoveTarget = targetTab.offsetTop - this.tabBlank
      wrap.scrollTo({ top: this.tabMoveTarget, left: 0, behavior: 'smooth' })
      // const wrap = document.getElementsByClassName('content-section')[0].closest('.wrap')
      // const targetTab = document.getElementsByClassName('tab-cont')[tab.name - 1]
      // wrap.scrollTo({ top: targetTab.offsetTop - this.tabBlank, left: 0, behavior: 'smooth' })
    },
    loginAlert () {
      this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
    },
    replaceImg (url, resizeInfo = undefined) {
      if (!this.isNotEmpty(url)) {
        return ''
      } else {
        let result = process.env.CDN_BASE_URL

        if (result !== '' && url.startsWith(result)) {
          return url
        }

        if (url.charAt(0) !== '/') {
          result = result + '/'
        }
        result = result + url
        if (resizeInfo) {
          result = result + resizeInfo
        }
        console.log('replaceImg result : ', result)
        return result
      }
    },

    replacePrfImg (url, resizeInfo) {
      if (!this.isNotEmpty(url)) {
        return '/images/icon/profile_noimg.png'
      } else {
        return this.replaceImg(url, resizeInfo)
      }
    },

    // onScroll () { // 스크롤 시 작동
    //   this.scrollY = Math.round(document.getElementsByClassName('content-section')[0].closest('.wrap').scrollTop)

    //   if (this.tabMoveTarget === this.scrollY) {
    //     this.tabMove = false
    //   }
    // }

    async selCtenStat (ctenId, admView) {
      let wrong = false
      let delYn = false
      let blndYn = false

      await this.$AxiosBuilder
        .data({ ctenId })
        .build()
        .post('/ug/common/selCtenStat')
        .then((res) => {
          if (!res || !res.data.data) {
            wrong = true
          } else {
            delYn = res.data.data.delYn === 'Y'
            blndYn = res.data.data.blndYn === 'Y'
          }
        })
        .catch(() => { wrong = true })
      // BO 관리자 조회
      if (this.isNotEmpty(admView) && admView === 'Y') {
        blndYn = false
      }

      let message = null
      if (wrong) {
        message = '조회할 수 없는 콘텐츠입니다.'
      } else if (delYn) {
        message = '삭제된 콘텐츠입니다.'
      } else if (blndYn) {
        message = '운영상 블라인드 처리된 콘텐츠입니다.'
      }

      if (this.isNotEmpty(message)) {
        this.$alert(message)
          .then(() => {
            this.$router.push(('/'))
          })
      }

      return this.isNotEmpty(message)
    },

    hasPrivateInfo (value) { // 주민등록번호 체크는 잠정 중지요청. 2023.12.18 최세* 현업
      return this.emailIncdChk(value) || this.cardIncdChk(value) || this.phoneIncdChk(value) || this.driveLicenseIncdChk(value) // || this.rrnIncdChk(value)
    },

    async hasBnwd (searchTerm) {
      let retVal = false
      await this.$AxiosBuilder
        .params({ searchTerm })
        .baseURL(process.env.API_SSN_BASE_URL2)
        .build()
        .get('/bnwdSearch')
        .then((res) => {
          retVal = res.data.resultSet.result[0].resultDocuments.length > 0
        })
        .catch((err) => {
          console.log(err)
          this.$alert('일시적인 오류가 발생하였습니다. 잠시 후에 다시 시도해주세요.')
          retVal = 'connFail'
        })
      return retVal
    },

    async getPrfImg () {
      let imgUrl = '/images/icon/profile_noimg.png'
      await this.$AxiosBuilder
        .data({ mbMngNo: this.$store.getters['session/getMbMngNo'] })
        .build()
        .post('/ug/ugp/selPrf')
        .then((res) => {
          if (this.isNotEmpty(res.data.data) && res.data.data.profileAtchUrl) {
            imgUrl = this.replaceImg(res.data.data.profileAtchUrl, this.$t('UG.RESIZE_PROFILE'))
          }
        })

      return imgUrl
    },
    getFileType (file) {
      const dotIndex = file.name.lastIndexOf('.')
      const fileType = file.name.substr(dotIndex + 1, file.name.length - dotIndex).toLowerCase()

      if (fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png') {
        return 'image'
      } else if (fileType === 'avi' || fileType === 'mp4' || fileType === 'mov') {
        return 'video'
      } else if (fileType === 'pdf') {
        return 'pdf'
      } else {
        return 'file'
      }
    },

    uploadFileChk (file, lmSize) {
      console.log('uploadFileChk')
      const fileVol = file.size / 1024 / 1024
      const fileType = this.getFileType(file)
      if (fileType === 'image' || fileType === 'pdf') {
        if (fileVol > lmSize) {
          this.alert('사진 업로드 용량은 최대 ' + lmSize + 'MB 입니다.')
          return false
        }
      } else if (fileType === 'video') {
        if (fileVol > lmSize) {
          this.alert('동영상 업로드 용량은 최대 ' + lmSize + 'MB 입니다.')
          return false
        }
      } else {
        this.alert('업로드 가능한 파일 형식이 아닙니다.')
        return false
      }
      return true
    }
  }
}

const ugAncm = {
  data () {
    return {
      ctenId: this.$route.query.ctenId,
      lgnMbMngNo: this.$store.getters['session/getMbMngNo'],
      ancmItem: {
        ansObjtrMbMngNo: '',
        ansObjtrNm: '',
        tagKeyword: '',
        textarea_max: '',
        bTextarea_max: '',
        metnUserList: [],
        filteredMetnUserList: [],
        metnVisible: false,
        mentionable: true
      },
      ancmForm: {
        ctenId: this.$route.query.ctenId,
        currentPage: 1,
        pageSize: 3,
      },
      commentList: [], // 댓글,답글
      currentPageCnt: 0,
      totalCnt: 0,
      isCtenMb: 'N', // 콘텐츠 회원여부
    }
  },

  computed: {
    ancmMinLength () {
      return 1
    },
    ancmMaxLength () {
      return 140
    },
  },

  watch: {
    'ancmForm.currentPage' (newValue, oldValue) {
      if (oldValue !== newValue) {
        this.selCtenAncmList()
      }
    },
  },

  methods: {
    itemInit () {
      this.ancmItem.ansObjtrMbMngNo = ''
      this.ancmItem.ansObjtrNm = ''
      this.ancmItem.tagKeyword = ''
      this.ancmItem.textarea_max = ''
      this.ancmItem.bTextarea_max = ''
      this.ancmItem.metnUserList = []
      this.ancmItem.filteredMetnUserList = []
      this.ancmItem.metnVisible = false
      this.ancmItem.mentionable = true
    },

    convertHtml (item, type) {
      const text = type === 'comment' ? item.comment : item.reply

      return this.unescape(text.replace(`#{{${item.ansObjtrMbMngNo}}}`, `<span class="tag">@${item.ansObjtrNm}</span>`))
    },

    convertText (item, type) {
      const text = type === 'comment' ? item.comment : item.reply

      return text.replace(`#{{${item.ansObjtrMbMngNo}}}`, `@${item.ansObjtrNm}`)
    },

    openUdpAncmAns (item) { // 답글 수정 오픈
      item.modyStatus = true
      item.textarea_modi = item.bTextarea_max = this.convertText(item, 'reply')
      item.metnVisible = false
      item.mentionable = false
    },

    // 댓글 답글달기 오픈
    openAncmAns (item) {
      item.replyItem = {
        ansObjtrMbMngNo: item.mbMngNo,
        ansObjtrNm: item.userName
      }

      item.replyInput = true
      item.textarea_reply = item.bTextarea_max = '@' + item.replyItem.ansObjtrNm + ' '
      item.metnVisible = false
      item.mentionable = false
    },

    // 댓글 수정 오픈
    openUdpAncm (item) {
      item.modyStatus = true
      item.textarea_modi = item.bTextarea_max = this.convertText(item, 'comment')

      item.tagKeyword = ''
      item.metnVisible = false
      item.mentionable = true

      console.log('[' + item.ansObjtrMbMngNo + ' ' + item.ansObjtrNm + ']')

      this.selMetnUserList(item)
    },

    closeAncm (item) { // 댓글, 답글 수정 닫기(취소포함)
      item.modyStatus = false
      item.textarea_max = ''
      item.textarea_modi = ''
    },

    closeAncmAns (item) { // 댓글 답글달기 닫기(취소포함)
      item.replyInput = false
      item.textarea_reply = ''
      item.replyItem = null
    },

    selectMetnUser (item, metnItem, modi) {
      if (modi) {
        item.textarea_modi = item.textarea_modi.replace('@' + item.tagKeyword, '@' + metnItem.mbNknmNm + ' ')
      } else {
        item.textarea_max = item.textarea_max.replace('@' + item.tagKeyword, '@' + metnItem.mbNknmNm + ' ')
      }

      item.ansObjtrMbMngNo = metnItem.mbMngNo
      item.ansObjtrNm = metnItem.mbNknmNm
      item.metnVisible = false
      item.tagKeyword = ''

      item.metnUserList = item.filteredMetnUserList = []
    },

    selMetnUserList (item) {
      this.$AxiosBuilder
        .data({ ctenId: this.ctenId })
        .build()
        .post('/ug/common/selMetnUserList')
        .then((res) => {
          console.log(res.data.data)

          if (this.isNotEmpty(res.data.data)) { // 댓글답글 멘션유저 목록
            const data = res.data.data
            this.metnUserList = item.filteredMetnUserList = data.selMetnUserList
          } else {
            this.metnUserList = item.filteredMetnUserList = []
          }
        })
    },

    handleInput (val, item, modi) {
      if (item.mentionable) {
        if (this.isBlank(item.ansObjtrMbMngNo)) {
          if (/[@]/.test(val)) {
            const tmp = val.substring(val.indexOf('@') + 1).split(' ')
            item.tagKeyword = tmp[0]

            item.filteredMetnUserList = this.metnUserList.filter((itm) => { return itm.mbNknmNm.indexOf(item.tagKeyword) === 0 })
            item.metnVisible = true
          }
        } else if (!/[@]/.test(val)) {
          item.ansObjtrMbMngNo = ''
          item.metnVisible = false
        } else if (!val.includes('@' + item.ansObjtrNm)) {
          if (modi) {
            item.textarea_modi = item.bTextarea_max.replace(item.ansObjtrNm, '')
          } else {
            item.textarea_max = item.bTextarea_max.replace(item.ansObjtrNm, '')
          }

          item.tagKeyword = ''
          item.filteredMetnUserList = this.metnUserList

          item.metnVisible = true
        }
      }

      item.bTextarea_max = modi ? item.textarea_modi : item.textarea_max
    },

    async hasBnwd (searchTerm) {
      let retVal = false

      await this.$AxiosBuilder
        .params({ searchTerm })
        .baseURL(process.env.API_SSN_BASE_URL2)
        .build()
        .get('/bnwdSearch')
        .then((res) => {
          retVal = res.data.resultSet.result[0].resultDocuments.length > 0
          if (retVal) {
            this.$alert('작성하신 글에 금칙어가 포함되어 입력이 불가능합니다.')
          }
        })
        .catch((err) => {
          console.log(err)
          this.$alert('일시적인 오류가 발생하였습니다. 잠시 후에 다시 시도해주세요.')
          retVal = true
        })

      return retVal
    },

    hasPrivateInfo (value) {
      return this.emailIncdChk(value) || this.cardIncdChk(value) || this.phoneIncdChk(value) || this.rrnIncdChk(value) || this.driveLicenseIncdChk(value)
    },

    // 로그인, 프로필 작성 유도 Validation
    validMb () {
      const mbInfo = this.$store.getters['session/getMb']
      if (mbInfo.mbMngNo === undefined) {
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return false
      }

      if (mbInfo.userTy === '40' || mbInfo.userTy === '50') {
        this.$alert('일반회원만 작성 가능합니다.')
        return false
      }

      if (this.isCtenMb === 'N') {
        this.$confirm(this.$t('UG.REG_PROFILE'), '', {
          cancelButtonText: '취소',
          confirmButtonText: '확인'
        }).then(() => {
          this.$router.push({ name: 'ug-ugp-SCR_UGP_0018', params: { returnUrl: this.$route.fullPath } })
        }).catch(() => {
          return false
        })
        return false
      }

      return true
    },

    async checkValidation (value) {
      if (!this.validMb()) {
        return false
      }

      if (this.hasPrivateInfo(value)) {
        this.$alert('작성하신 글에 개인정보가 포함되어 입력이 불가능합니다.')
        return false
      } else if (await this.hasBnwd(value)) {
        return false
      }

      return true
    },

    // 댓글 답글 목록조회
    selCtenAncmList () {
      this.$AxiosBuilder
        .data(this.ancmForm)
        .build()
        .post('/ug/common/selCtenAncmList')
        .then((res) => {
          if (this.isNotEmpty(res.data.data)) {
            // 댓글답글 목록
            const data = res.data.data
            this.commentList = data.commentList
            this.totalCnt = this.commentList.length > 0 ? data.commentList[0].totalCnt : 0

            console.log(this.totalCnt)

            const ctenMb = data.isCtenMb
            if (ctenMb !== null && ctenMb !== undefined) {
              this.isCtenMb = ctenMb
            }
          } else {
            this.commentList = []
            this.totalCnt = 0
            this.currentPageCnt = 0
          }
        })
    },

    // 주댓글 등록
    async addAncm () { // 주댓글 등록
      if (!await this.checkValidation(this.ancmItem.textarea_max)) {
        return false
      }

      this.$confirm('등록하시겠습니까?', '', {
        cancelButtonText: '취소',
        confirmButtonText: '확인',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          const ansObjtrMbMngNo = this.ancmItem.ansObjtrMbMngNo
          const ansObjtrNm = this.ancmItem.ansObjtrNm
          const ancmCn = this.isBlank(this.ancmItem.ansObjtrMbMngNo) ? this.ancmItem.textarea_max : this.ancmItem.textarea_max.replace('@' + this.ancmItem.ansObjtrNm, `#{{${this.ancmItem.ansObjtrMbMngNo}}}`)

          await this.$AxiosBuilder
            .data({ ctenId: this.ctenId, ancmCn, lgnMbMngNo: this.lgnMbMngNo, ancmLvlNo: '1', ansObjtrMbMngNo, ansObjtrNm })
            .build()
            .post('/ug/common/insAncm')
            .then((res) => {
              if (res.data.success) {
                this.itemInit()
                this.selCtenAncmList()
                this.openToast(this.$t('UG.COMMENT_SUCCESS')) /* 댓글이 등록되었습니다 */
              } else {
                this.ntcnMsg(res.data.message)
              }
            })
        } catch (err) {
          console.log(err)
        }
      })
    },

    // 주댓글 수정
    async udpAncm (item) {
      if (!await this.checkValidation(item.textarea_modi)) {
        return false
      }

      this.$confirm('수정 저장하시겠습니까?', '', {
        cancelButtonText: '닫기',
        confirmButtonText: '수정',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          const ansObjtrMbMngNo = item.ansObjtrMbMngNo
          const ansObjtrNm = item.ansObjtrNm
          const ancmCn = this.isBlank(item.ansObjtrMbMngNo) ? item.textarea_modi : item.textarea_modi.replace('@' + ansObjtrNm, `#{{${ansObjtrMbMngNo}}}`)

          await this.$AxiosBuilder
            .data({
              ctenId: this.ctenId, ancmId: item.ancmId, ancmCn, lgnMbMngNo: this.lgnMbMngNo, ansObjtrMbMngNo, ansObjtrNm
            })
            .build()
            .post('/ug/common/updAncm')
            .then((res) => {
              if (res.data.success) {
                this.closeAncm(item)
                this.selCtenAncmList()
              } else {
                this.ntcnMsg(res.data.message)
              }
            })
        } catch (err) {
          console.log(err)
        }
      })
    },

    async insAncmAns (item) { // 답글등록
      if (!await this.checkValidation(item.textarea_reply)) {
        return false
      }

      this.$confirm('답글을 등록하시겠습니까?', '', {
        cancelButtonText: '닫기',
        confirmButtonText: '등록',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          const ansObjtrMbMngNo = item.replyItem.ansObjtrMbMngNo
          const ansObjtrNm = item.replyItem.ansObjtrNm
          const ancmCn = this.isBlank(item.replyItem.ansObjtrMbMngNo) ? item.textarea_reply : item.textarea_reply.replace('@' + ansObjtrNm, `#{{${ansObjtrMbMngNo}}}`)

          await this.$AxiosBuilder
            .data({
              ctenId: this.ctenId,
              ancmId: item.ancmId,
              ancmCn,
              lgnMbMngNo: this.lgnMbMngNo,
              grpInsdNo: item.grpInsdNo,
              ancmLvlNo: '2',
              ansObjtrMbMngNo,
              ansObjtrNm
            })
            .build()
            .post('/ug/common/insAncm')
            .then((res) => {
              if (res.data.success) {
                this.openToast('답글이 등록되었습니다.')
                this.closeAncmAns(item)
                this.selCtenAncmList()
              } else {
                this.ntcnMsg(res.data.message)
              }

              this.ansObjtrMbMngNo = this.ansObjtrNm = ''
            })
        } catch (err) {
          console.log(err)
        }
      })
    },

    openToast (msg) {
      this.$notify({
        // title: 'Custom Position',
        message: msg,
        position: 'center',
        showClose: false,
        duration: 3000,
        onClick: () => { this.$notify.closeAll() }

      })
    }
  }

}

export {
  ugMixin,
  ugAncm
}
